<h1 mat-dialog-title>An error has occurred!</h1>
<div mat-dialog-content>
  <p *ngIf="data.error?.message">
    <b>{{data?.error.message}}</b>
  </p>
  <p *ngIf="!data.error?.message">
    <b>Something went wrong!</b>
  </p>
  <ul class="error-message" *ngIf="data?.error?.errors">
    <li *ngFor="let fieldErr of data.error.errors">
      {{ fieldErr.field }}: {{ fieldErr.message }}
    </li>
  </ul>
  <p *ngIf="data.status">
    Status Code: {{data.status}}
  </p>
  <!-- Support correlation: the running bundle, plus the failed response's
       X-Request-Id when it carried one. The request-id half is omitted rather
       than rendered empty (console-automatic-upgrade). -->
  <p class="error-context">
    Console {{version}}<span *ngIf="data.requestId"> &middot; Request Id {{data.requestId}}</span>
  </p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button mat-dialog-close color="primary">
    Close
  </button>
</div>
